import React, { useEffect, useMemo, useState } from 'react';
import { useCnRequest } from '@cainiaofe/cn-ui-utils';
import { useLatest } from 'ahooks';
export const FormatEnumeration = (props) => {
    const { value, column = {} } = props;
    const { options = {} } = column;
    const { dataSource: dataSourceProps, requestConfig } = options;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(!dataSourceProps);
    const requestConfigRef = useLatest(requestConfig);
    const { runAsync } = useCnRequest({
        manual: true,
        cacheKey: `${requestConfig?.url}+${requestConfig?.method}+${JSON.stringify(requestConfig?.params || {})}`,
        staleTime: 5000,
        ...requestConfig,
    });
    useEffect(() => {
        if (dataSourceProps || !value) {
            setLoading(false);
            return;
        }
        const config = requestConfigRef.current;
        if (config) {
            runAsync()
                .then((data) => setDataSource(data))
                .finally(() => setLoading(false));
        }
    }, [dataSourceProps, requestConfigRef, runAsync, value]);
    const result = useMemo(() => {
        if (!value)
            return;
        const list = dataSourceProps || dataSource;
        if (Array.isArray(value)) {
            return value
                .map((valueItem) => list.find((item) => item.value === valueItem)?.label)
                .filter(Boolean)
                .join(',');
        }
        return list.find((item) => item.value === value)?.label;
    }, [dataSource, dataSourceProps, value]);
    if (loading)
        return null;
    return React.createElement(React.Fragment, null, result || value || '- -');
};
